export default __webpack_public_path__ + "static/media/step3.4617abf1.mp4";